"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeChartDataCumulative = exports.addCohortToChartData = exports.getProjectStickinessResultByChunks = void 0;
const ICCanisterUtils_1 = require("src/hello_assets/src/util/ICCanisterUtils");
const async_1 = __importDefault(require("async"));
const lodash_1 = __importDefault(require("lodash"));
const ArrayCalculationsFacade_1 = require("src/hello_assets/src/util/ArrayCalculationsFacade");
const LineTypeJSONModel_1 = require("src/hello_assets/src/components/model/common/LineTypeJSONModel");
const DateTimeFacade_1 = require("src/hello_assets/src/util/DateTimeFacade");
const AnalyticsStoreRestApi_1 = require("src/hello_assets/src/components/ui/loggedin/content/common/provider/AnalyticsStoreRestApi");
const getNumberOfChunksByLastNDays = (lastNDays) => {
    if (lastNDays >= 180) {
        return 128;
    }
    if (lastNDays >= 90) {
        return 64;
    }
    if (lastNDays >= 60) {
        return 32;
    }
    if (lastNDays >= 30) {
        return 16;
    }
    if (lastNDays >= 15) {
        return 8;
    }
    return 2;
};
const getProjectStickinessResultByChunks = async (actors, accessToken, parameters) => {
    return new Promise((resolve, reject) => {
        // if (process.env.NODE_ENV === "development") {
        //     console.log("StickinessApiService.getProjectStickinessResultByChunks!!!! lastNDays", lastNDays);
        // }
        const { periodType, lineType, cohortQuery, returnQuery } = parameters;
        const lastNDays = periodType.last;
        const numberOfChunksByLastNDays = getNumberOfChunksByLastNDays(lastNDays);
        if (!!process.env.IS_TEST_SERVER) {
            console.log("getProjectStickinessResultByChunks numberOfChunksByLastNDays", { lastNDays, numberOfChunksByLastNDays });
        }
        const ranges = (0, ICCanisterUtils_1.splitPartitionsCountIntoChunks)(numberOfChunksByLastNDays, ICCanisterUtils_1.USERS_PARTITIONS_COUNT);
        const tasks = lodash_1.default.flatten(lodash_1.default.map(actors, (actor, actorIdx) => {
            return lodash_1.default.flatten(lodash_1.default.map(ranges, (range, rangeIdx) => {
                const cumulativeIdx = ranges.length * actorIdx + rangeIdx;
                return (callback) => {
                    (async () => {
                        try {
                            const result = await AnalyticsStoreRestApi_1.AnalyticsStoreRestApi.getProjectStickinessChunkNew(actor, accessToken, cohortQuery, returnQuery, { lastNDays: lastNDays, partitionsRange: range });
                            const taskResult = { idx: cumulativeIdx, actorIndex: actorIdx, chunk: result };
                            callback(null, taskResult);
                        }
                        catch (e) {
                            callback(e);
                        }
                    })();
                };
            }));
        }));
        async_1.default.parallelLimit(tasks, 10, (err, results) => {
            if (!lodash_1.default.isNil(err)) {
                console.warn("getProjectStickinessChunk promises failure: at least one of the chunks failed", err);
                resolve({ err: { "temporarilyUnavailable": null } });
            }
            else {
                if (!!process.env.IS_TEST_SERVER) {
                    console.log("getProjectStickinessChunk promises results", results);
                }
                try {
                    const tasksResult = results;
                    const thereAreErrors = lodash_1.default.some(tasksResult, (taskResult) => {
                        if ((taskResult === null || taskResult === void 0 ? void 0 : taskResult.chunk) == undefined) {
                            return true;
                        }
                        return (0, ICCanisterUtils_1.isICRequestErr)(taskResult.chunk);
                    });
                    if (thereAreErrors) {
                        console.warn("getProjectStickinessChunk promises failure: there are backend errors", tasksResult);
                        resolve({ err: { "temporarilyUnavailable": null } });
                        return;
                    }
                    else {
                        //all chunk errors (by checking "isICRequestErr") made above. So here all variants are "#ok".
                        const retentionChartResultDataArray = lodash_1.default.compact(lodash_1.default.map(tasksResult, (taskResult) => {
                            if (taskResult != undefined && (0, ICCanisterUtils_1.isICRequestOk)(taskResult.chunk)) {
                                return {
                                    idx: taskResult.idx,
                                    actorIndex: taskResult.actorIndex,
                                    chunkData: taskResult.chunk.ok
                                };
                            }
                        }));
                        if (!!process.env.IS_TEST_SERVER) {
                            console.log("getProjectStickinessChunk promises: retentionChartResultDataArray", retentionChartResultDataArray);
                        }
                        if (retentionChartResultDataArray.length > 0) {
                            const firstData = retentionChartResultDataArray[0].chunkData;
                            const intervalStartTimeMillis = DateTimeFacade_1.DateTimeFacade.getMomentFromMillis(firstData.intervalStartTimeSec * 1000).startOf("day").valueOf();
                            const intervalStartTimeSec = Math.floor(intervalStartTimeMillis / 1000);
                            const retentionPeriods = lodash_1.default.cloneDeep(firstData.periods);
                            let chartData = new Array(firstData.chartData.length).fill(new Int32Array());
                            for (let i = 0; i < chartData.length; i++) {
                                const hasData = lodash_1.default.some(retentionChartResultDataArray, (arr) => {
                                    const currentChartData = arr.chunkData.chartData[i];
                                    return currentChartData != undefined && currentChartData.length > 0;
                                });
                                if (hasData) {
                                    const sumOfArray = ArrayCalculationsFacade_1.ArrayCalculationsFacade.sumArray(retentionChartResultDataArray.map(val => Array.from(val.chunkData.chartData[i])));
                                    chartData[i] = Int32Array.from(sumOfArray);
                                }
                            }
                            // if (process.env.NODE_ENV === "development") {
                            //     console.log("stickiness server chartData", _.cloneDeep(chartData));
                            // }
                            const resultData = (0, exports.addCohortToChartData)({
                                chartData: chartData,
                                periods: retentionPeriods,
                                intervalStartTimeSec: intervalStartTimeSec
                            });
                            if (lineType === LineTypeJSONModel_1.LineType.cumulative) {
                                resultData.chartData = (0, exports.makeChartDataCumulative)(resultData.chartData);
                                // if (process.env.NODE_ENV === "development") {
                                //     console.log("stickiness adjusted chartData cumulative", _.cloneDeep(resultData.chartData));
                                // }
                            }
                            else {
                                // if (process.env.NODE_ENV === "development") {
                                //     console.log("stickiness adjusted chartData", _.cloneDeep(resultData.chartData));
                                // }
                            }
                            const stickinessResult = {
                                ok: resultData
                            };
                            if (!!process.env.IS_TEST_SERVER) {
                                console.log("getProjectStickinessChunk stickinessResult", stickinessResult);
                            }
                            resolve(stickinessResult);
                            return;
                        }
                        else {
                            console.warn("getProjectStickinessChunk promises failure: no success results", tasksResult);
                            resolve({ err: { "temporarilyUnavailable": null } });
                            return;
                        }
                    }
                }
                catch (e) {
                    console.warn("getProjectStickinessChunk failed", e);
                    resolve({ err: { "temporarilyUnavailable": null } });
                    return;
                }
            }
        });
    });
};
exports.getProjectStickinessResultByChunks = getProjectStickinessResultByChunks;
/**
 * Method adds cohort as a first array element
 * @param resultData StickinessChartResultData object from the server (chartData array<array<number>> with 7 elements)
 * @return StickinessChartResultData object (chartData array<array<number>> with 8 elements)
 */
const addCohortToChartData = (resultData) => {
    resultData = lodash_1.default.cloneDeep(resultData);
    //add cohort as a first array element
    const periodsCount = resultData.periods.length;
    const chartDataAsNumbers = Array.from(resultData.chartData, v => Array.from(v));
    const newChartData = lodash_1.default.map(chartDataAsNumbers, value => {
        if (lodash_1.default.isEmpty(value)) {
            value = new Array(periodsCount + 1).fill(0);
        }
        else {
            value.unshift(lodash_1.default.sum(value));
        }
        return Int32Array.from(value);
    });
    resultData.chartData = newChartData;
    return resultData;
};
exports.addCohortToChartData = addCohortToChartData;
const makeChartDataCumulative = (chartData) => {
    chartData = lodash_1.default.cloneDeep(chartData);
    chartData = lodash_1.default.map(chartData, (value) => {
        if (value.length === 0) {
            return value;
        }
        const valueCopy = lodash_1.default.cloneDeep(value);
        for (let i = valueCopy.length - 1; i >= 0; i--) {
            if (i > 0 && i < valueCopy.length - 1) {
                valueCopy[i] = valueCopy[i] + valueCopy[i + 1];
            }
        }
        return valueCopy;
    });
    return chartData;
};
exports.makeChartDataCumulative = makeChartDataCumulative;
